// OIChart — Open Interest bar chart (Angel One Light Theme)
import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

export default function OIChart({ strikes }) {
  const data = useMemo(() => {
    if (!strikes) return [];
    return strikes
      .filter(s => s.call || s.put)
      .map(s => ({
        strike: s.strike,
        callOI: s.call?.openInterest || 0,
        putOI: s.put?.openInterest || 0,
      }));
  }, [strikes]);

  if (data.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 text-center text-xs text-gray-400">No OI data</div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4">
      <h4 className="text-[10px] font-semibold text-gray-600 uppercase tracking-wider mb-3">Open Interest</h4>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={data} margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
          <XAxis
            dataKey="strike"
            tick={{ fontSize: 8, fill: '#6B7280' }}
            axisLine={{ stroke: '#E5E7EB' }}
            tickLine={false}
            interval="preserveStartEnd"
          />
          <YAxis
            tick={{ fontSize: 8, fill: '#6B7280' }}
            axisLine={{ stroke: '#E5E7EB' }}
            tickLine={false}
            tickFormatter={v => {
              if (v >= 100000) return (v / 100000).toFixed(0) + 'L';
              if (v >= 1000) return (v / 1000).toFixed(0) + 'K';
              return v;
            }}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (!active || !payload?.[0]) return null;
              const d = payload[0].payload;
              return (
                <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-2 text-[10px]">
                  <p className="text-gray-600 mb-1 font-medium">Strike: {d.strike}</p>
                  <p className="text-green-600">Call OI: {d.callOI?.toLocaleString('en-IN')}</p>
                  <p className="text-red-500">Put OI: {d.putOI?.toLocaleString('en-IN')}</p>
                </div>
              );
            }}
          />
          <Bar dataKey="callOI" fill="rgba(22, 163, 74, 0.6)" radius={[2, 2, 0, 0]} />
          <Bar dataKey="putOI" fill="rgba(239, 68, 68, 0.5)" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
